import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs
} from '@bepatient/core';
import { IonicModule } from '@ionic/angular';
import { EffectsModule } from '@ngrx/effects';
import { DeleteEventPopupComponent } from './components/delete-event-popup/delete-event-popup.component';
import { EventsUtilsService } from './events-utils.service';
import { EventsEffects } from './events.effects';

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.EVENTS,
  i18nLabel: 'MODULES.EVENTS',
  icon: 'pulse',
  leftMenuAvailableForPages: [0, 1, 2, 3],
  routes: [
    {
      path: 'events-list',
      loadChildren: () =>
        import('./pages/list/list.module').then(
          module => module.EventsListPageModule
        )
    },
    {
      path: 'new-event',
      loadChildren: () =>
        import('./pages/new-event/new-event.module').then(
          module => module.NewEventPageModule
        )
    },
    {
      path: 'update-event',
      loadChildren: () =>
        import('./pages/update-event/update-event.module').then(
          module => module.UpdateEventPageModule
        )
    }
  ]
};

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild(pageModule.routes),
    EffectsModule.forFeature([EventsEffects])
  ],
  providers: [
    EventsUtilsService,
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './events/i18n/', multi: true }
  ],
  declarations: [DeleteEventPopupComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EventsModule {}
